export default __webpack_public_path__ + "static/media/element_64.46a478e8.avif";